import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { logout, refreshSession } from '../actions/constants'
import { IJWTToken } from '../../models/token'

export interface ITokenState {
  token: IJWTToken | null,
  sessionGeneration: number,
}

const initialState: ITokenState = {
  token: null,
  sessionGeneration: 0
}

export const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<IJWTToken | null>) => {
      state.token = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => ({
      ...initialState,
      sessionGeneration: (state.sessionGeneration ?? 0) + 1
    }))
  }
})

export const { setToken } = tokenSlice.actions

export default tokenSlice.reducer
